import { render, staticRenderFns } from "./appointmentForm.vue?vue&type=template&id=88ee3974&scoped=true"
import script from "./appointmentForm.vue?vue&type=script&lang=js"
export * from "./appointmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ee3974",
  null
  
)

export default component.exports